export default "__VITE_ASSET__CJFYsHS9__"